import { useState, useEffect } from 'react'
import CompanyInfo from '../../../components/CompanyInfo'
import ResearchSection from '../../../components/visualizationPanel/components/ResearchSection'
import { SectionProvider } from '../../../context/section'
import TooltipButton from '../../../components/ui/TooltipButton'
import { ProjectProvider, useProject } from '../../../context/project'
import ProjectRestoationModal from '../../../components/ProjectRestoationModal'
import Modal from '../../../components/Modal'
import Spinner from '../../../components/Spinner'
import AlertModal from '../../../components/visualization-dropdown/AlertModal'
import { Container, Skeleton } from '@mui/material'
import { AddOutlined, CloseFullscreenTwoTone} from '@mui/icons-material'
import AlertsBoard from '../../../components/AlertsBoard'
import useHistory from '../../../hooks/useHistory'
import DragDropComponent from '../../../components/DragDropComponent'
import styles from './Visualization.module.scss'
import { useGeneral } from '../../../context/general'
import history from '../../../history'

const emptyForm = {        
    alertType: 'datasetTrend',
    selectedDataset: {columnValue:'', columnName:'', datasetValue:'', datasetName:''},
    change: 5,
    timePeriod: "",
    agg:'mean'
}

function Research() {
    const { sections, colapseAll, addPanel, tickerInfo, ticker, projectId, isLoading, earningsData, handleReorderSections, doesProjectExist } = useProject()
    const [openAlert, setOpenAlert] = useState(false)
    const [openAlertsBoard, setOpenAlertsBoard] = useState(false)
    const [ form, setForm ] = useState(emptyForm)
    const [alertToEdit, setAlertToEdit] = useState(null)
    const {goToPageNotFound} = useHistory()

    const handleAlert = () => setOpenAlert(true)

    const closeMenu = () => {
        setOpenAlert(false)
        setAlertToEdit(null)
        setForm(emptyForm)
    }

    useEffect(() => {!doesProjectExist && goToPageNotFound();return () => {}}, [doesProjectExist, goToPageNotFound])

    return (
        <>
            <AlertsBoard open={openAlertsBoard} setOpen={setOpenAlertsBoard} setOpenAlert={setOpenAlert} setAlertToEdit={setAlertToEdit}/>
            <div className={styles["research"]}>
                <Container maxWidth="xl" component="section">
                    <CompanyInfo tickerInfo={tickerInfo} ticker={ticker} projectId={projectId} setOpenAlertsBoard={setOpenAlertsBoard} earningsData={earningsData}/>
                    <div className={styles['section-btns']}>
                        {/* <TooltipButton onClickFunc={handleAlert} title="Add New Alert">
                            + Add Alert
                        </TooltipButton> */}
                        <TooltipButton onClickFunc={colapseAll} title="Collapse All">
                            <CloseFullscreenTwoTone fontSize='small' color='textSecondary'/>
                        </TooltipButton>
                        <TooltipButton onClickFunc={addPanel} title="Add New Panel">
                            <AddOutlined fontSize='small' color='textSecondary'/>
                        </TooltipButton>
                    </div>
                </Container>
                <DragDropComponent handleUpdate={handleReorderSections} droppableId='sections' listItems={sections}>
                    {(sectionId) => (
                        <SectionProvider sectionId={sectionId} key={`section-provider-${sectionId}`}>
                            <ResearchSection projectId={projectId} />
                        </SectionProvider>)}
                </DragDropComponent>
                <Container maxWidth="xl" component="section" className={styles['add-panel']}>
                    <div onClick={addPanel}>
                        <p>+ Add Panel</p>
                    </div>
                </Container>
            </div>
            <ProjectRestoationModal projectId={projectId} tickerInfo={tickerInfo} ticker={ticker}/>
            <Modal open={isLoading} elevation={10}> <Spinner/> </Modal>
            <AlertModal open={openAlert} closeMenu={closeMenu} form={form} setForm={setForm} alertToEdit={alertToEdit} emptyForm={emptyForm}/>
        </>
    )
}

export default function VisualizationProvider() {
    const ProjectID = window.location.href.split('projectId=')[1]
    const { handleCreateProjectAndOpen, setprojectTickerData, tickers, projects } = useGeneral()
    const [LatestProjectId, setLatestProjectID ] = useState('')
    const [ticker, setTicker] = useState('')

    const handleProject = () =>{
        if (projects?.length){
            setLatestProjectID(projects[0].uuid)
            history.push(`/visualization?projectId=${projects[0].uuid}`)
        }
        else{
            if (tickers?.length){
            setTicker(tickers[0].value)
            setprojectTickerData(tickers[0])
            handleCreateProjectAndOpen(tickers[0].value)
        }}
    }


    useEffect(()=>{
        if (ProjectID && ProjectID!="null"){
            setLatestProjectID(ProjectID)
            history.push(`/visualization?projectId=${ProjectID}`)
        }
    },[ProjectID])

    useEffect(()=>{
        if (projects?.length & tickers?.length){
            if (!LatestProjectId)handleProject()
        }
    },[projects,tickers])
    


    return (
        <ProjectProvider>
            {tickers?.length?<Research />:<Skeleton height={500} />}
            {/* <Research /> */}
        </ProjectProvider>
    )
}
